export const methods = [
  "post",
  "get",
  "put",
  "patch",
  "delete",
  "options",
  "checkout",
  "copy",
  "purge",
  "head",
  "lock",
  "merge",
  "notify",
  "options",
  "report",
  "search",
  "subscribe",
  "unsubscribe",
  "trace",
  "unlock",
];
const prefix = [
  "onsite",
  "ruby",
  "admin",
  "authenticated",
  "upload",
  "attachmentUpload",
  "twilio",
];
export const keyWords = [...prefix, ...methods];
export const preserveKeyWords = ["path", "methods"];
export const onsiteHeader = "routeauth";
export const prefixes = prefix.reduce((acc, val) => {
  acc[val] = val;
  return acc;
}, {});
